var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdEMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,12c-2.2055664,0-4,1.7939453-4,4s1.7944336,4,4,4s4-1.7939453,4-4S26.2055664,12,24,12z M24,18 c-1.1030273,0-2-0.8974609-2-2s0.8969727-2,2-2s2,0.8974609,2,2S25.1030273,18,24,18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,24c-2.2055664,0-4,1.7939453-4,4s1.7944336,4,4,4s4-1.7939453,4-4S34.2055664,24,32,24z M32,30 c-1.1030273,0-2-0.8974609-2-2s0.8969727-2,2-2s2,0.8974609,2,2S33.1030273,30,32,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,24c-2.2055664,0-4,1.7939453-4,4s1.7944336,4,4,4s4-1.7939453,4-4S18.2055664,24,16,24z M16,30 c-1.1030273,0-2-0.8974609-2-2s0.8969727-2,2-2s2,0.8974609,2,2S17.1030273,30,16,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,2C11.8691406,2,2,11.8691406,2,24s9.8691406,22,22,22s22-9.8691406,22-22S36.1308594,2,24,2z M24,44 C12.972168,44,4,35.0283203,4,24S12.972168,4,24,4s20,8.9716797,20,20S35.027832,44,24,44z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdEMedium);
export default __webpack_public_path__ + "static/media/plug-household-e--medium.2ab4cf342e7a4d33db3b77062bcd110b.svg";
export { ForwardRef as ReactComponent };